import { Controller } from "@hotwired/stimulus"
import posthog from 'posthog-js'

export default class extends Controller {
  static values = {
    eventData: { type: Object, default: {} },
    eventName: String,
  }

  connect(){
    // Dont log events from development
    if (window.location.host.includes('127.0.0.1') || window.location.host.includes('localhost')) {
      return
    }

    if (this.hasEventNameValue && this.eventNameValue){
      posthog.capture(this.eventNameValue, this.eventDataValue)
    }
  }
}